export const defaultNavigationPart = {
  title: "",
  parent_id: 1,
  sort: null,
  path: "",
};
